import { createContext, Dispatch, ReactNode, SetStateAction, useState } from "react";
import { UserProfile } from "../types/connectionSocialNetworks";

type SocialNetworkProviderProps = {
  children: ReactNode;
};

export type SocialNetworkContextData = {
  socialNetwork: UserProfile | undefined;
  setSocialNetwork: Dispatch<SetStateAction<UserProfile | undefined>>;
  updateUserMutationNonCapturedError: boolean;
  setUpdateUserMutationNonCapturedError: Dispatch<SetStateAction<boolean>>;
  isConnected: boolean;
  setIsConnected: Dispatch<SetStateAction<boolean>>;
};

export const SocialNetworkContext =
  createContext(
    {} as SocialNetworkContextData
  );

export function SocialNetworkProvider({
  children,
}: SocialNetworkProviderProps) {
  const [socialNetwork, setSocialNetwork] = useState<UserProfile>()
  const [
    updateUserMutationNonCapturedError,
    setUpdateUserMutationNonCapturedError,
  ] = useState<boolean>(false);
  const [
    isConnected,
    setIsConnected,
  ] = useState<boolean>(false);

  return (
    <SocialNetworkContext.Provider value={{
      socialNetwork, 
      updateUserMutationNonCapturedError,
      isConnected,
      setIsConnected, 
      setSocialNetwork, 
      setUpdateUserMutationNonCapturedError
    }}>
      {children}
    </SocialNetworkContext.Provider>
  );
}
